export default __webpack_public_path__ + "static/media/rh.f4b5d33d.svg";